import React from 'react';
import { css, cx } from 'emotion';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { components } from '@peachjar/components';
import Typo from '@peachjar/ui/dist/lib/typography/TypographyRedux';
import { ButtonPrimarySmall } from '@peachjar/ui/dist/lib/components/Buttons';
import colors from '@peachjar/ui/dist/lib/styles/colors';

type Content = {
  headline: string,
  subheadline: string,
  subheadlineDeals: string,
  subheadline2: string,
  details: string,
  cta: string,
  ctaApplied: string,
};

type ModalAction = () => void;

type Props = {
  content: Content,
  promoApplied: boolean,
  classes: {
    [k: string]: any,
  },
  bannerImage: string,
  variant: string,
  credits: number,
  handleClick: (showModal: ModalAction, closeModal: ModalAction) => void,
};

const { ModalConsumer } = components;

const CyberSaleBanner = ({
  content,
  promoApplied,
  bannerImage,
  classes,
  credits,
  handleClick,
}: Props) => {
  const {
    headline,
    subheadline,
    subheadline2,
    details,
    cta,
    ctaApplied,
  } = content;

  return (
    <Grid item xs={12}>
      <Paper
        className={`${cn.banner} ${classes.elevation2
          }`}
      >
        <div className={cn.illustration}>
          <img src={bannerImage} alt={headline} />
        </div>
        <div className={cn.offerDetails}>
          <div className={cn.content}>
            <Typo.Dark.Headline2 style={{ marginBlockEnd: '8px' }}>{headline}</Typo.Dark.Headline2>
            <Typo.Dark.Paragraph
              className={cn.subheadline}
              dangerouslySetInnerHTML={{ __html: subheadline }}
            />

            <Typo.Dark.Paragraph
              className={cx(cn.subheadline, cn.subheadline2)}
              dangerouslySetInnerHTML={{ __html: subheadline2 }}
            />
            <Typo.Dark.Paragraph
              className={cn.details}
              dangerouslySetInnerHTML={{ __html: details }}
            />
          </div>
        </div>
        <div className={cn.cta}>
          <ModalConsumer>
            {({ showModal, closeModal }) => (
              <ButtonPrimarySmall
                data-testid="click-cyber-deal-20"
                onClick={() => handleClick(showModal, closeModal)}
                className={cn.ctaButton}
                disabled={credits}
              >
                {credits ? ctaApplied : cta}
              </ButtonPrimarySmall>
            )}
          </ModalConsumer>
        </div>
      </Paper>
    </Grid>
  );
};

const materialOverrides = {
  elevation2: {
    boxShadow: 'none',
  },
};

const cn = {
  banner: css`
    display: flex;
    flex-direction: 'row';
    border: 1px solid ${colors.mercury};
  `,
  defaultBanner: css``,
  subheadline: css`      
    font-size: 25px;
  `,
  subheadline2: css`
    display: block;
  `,
  illustration: css``,
  offerDetails: css``,
  content: css`      
    padding: 46px 88px 0px 46px;
  `,
  details: css`
    font-size: 13px;
    display: block;
    margin-top: 6px;
    color: ${colors.slate};
  `,
  cta: css`      
   margin-top: 98px;
  `,
  ctaButton: css``,
};

export default withStyles(materialOverrides)(CyberSaleBanner);
